import { Profile } from "./profile";
import { UserRole } from './role';

export class User {
    id: number
    role?: UserRole
    profile?: Profile    

    constructor(id: number, role?: UserRole, profile?: Profile) {
        this.id = id
        this.role = role
        this.profile = profile
    }
}